import { FAQ } from "@widgets/faq";
import { FC } from "react";

export const FAQPage: FC = () => {
  return <FAQ />;
};
